module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-rents-by-years"
  }, [_c('div', {
    staticClass: "thumbnail",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [(!_vm.chartOptions) ? _c('loading') : _c('highcharts', {
    ref: "highcharts",
    attrs: {
      "options": _vm.chartOptions
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9b6d2edc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/ChartRentsByYears.vue
// module id = 1028
// module chunks = 34